import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import ComerciosTodos from './ComerciosTodos';
import CentrosTodos from './CentrosTodos';
import ComerciosConsulta from './ComerciosConsulta';
import Mensaje from './Mensaje';
import Banner from './Banner';
import Rubros from './Rubros';

import InscripcionesConsulta from './InscripcionesConsulta';
import { useNavigate } from "react-router-dom";
import { useStore } from './store/comercioStore' ;
import SucursalesTodas from './SucursalesTodas';
import Grafico from './Grafico';
import Logos from './Logos';
import Footer2 from './Footer2';

function TabPanel(props) {
  const { children, value, index, ...other } = props;


  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function MenuCamaras() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate()
  const {  tipo ,asignaTipo} = useStore();

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleExit = () => {
    asignaTipo(0);
    navigate('/login')
  }
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
           <Tab label="Gestión Comercios" {...a11yProps(0)} />
          <Tab label="Inscripciones Consulta" {...a11yProps(1)} />
          <Tab label="Comercios Consulta" {...a11yProps(2)} />
          <Tab label="Centros Comerciales" {...a11yProps(3)} />

          
          <Button variant="contained" onClick={handleExit}>Salir</Button>
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <ComerciosTodos />
      </TabPanel>
      <TabPanel value={value} index={1}>
      <InscripcionesConsulta />
      </TabPanel>
      <TabPanel value={value} index={2}>
      <ComerciosConsulta />
      </TabPanel>
      <TabPanel value={value} index={3}>
      <CentrosTodos />
      </TabPanel> 
  
    < Footer2 /> 
    </Box>
  );
}

/*

          <Tab label="Sucursales" {...a11yProps(4)} />
          <Tab label="Mensaje" {...a11yProps(5)} />
          <Tab label="Banner" {...a11yProps(6)} />

          
      <TabPanel value={value} index={4}>
      <SucursalesTodas />
      </TabPanel>   
      <TabPanel value={value} index={5}>
      <Mensaje />
      </TabPanel>   
      <TabPanel value={value} index={6}>
      <Banner />
      </TabPanel>
*/
